module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter01"
    }
  }, [_vm._v("Author’s Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_vm._v("Wig")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dressing Up In Voices")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Slight Chill")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Borneo")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paint")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Men’s Sweetness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wheee!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Boys")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The List")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choking")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dangerous Pleasures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0